'use strict'

import css from './profile-dialog.component.scss'
import template from './profile-dialog.template.pug'

class ProfileDialogController {
  constructor($mdDialog, $state, SessionService, $http, $mdToast, UserService) {
    'ngInject'
    Object.assign(
      this,
      { $mdDialog, $state, SessionService, $http, $mdToast, UserService },
      {
        account: {},
        passwordMinLength: 8,
        nameMinLength: 2,
      },
    )
  }

  $onInit() {
    this.account.salutation = this.SessionService.currentUser.user.salutation
    this.account.firstname = this.SessionService.currentUser.user.firstname
    this.account.lastname = this.SessionService.currentUser.user.lastname
    this.account.email = this.SessionService.currentUser.user.email
    this.account.phone = this.SessionService.currentUser.user.phone
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  updateAccount() {
    const newUserData = {
      salutation: this.account.salutation,
      firstname: this.account.firstname,
      lastname: this.account.lastname,
      phone: this.account.phone || null,
    }
    return this.UserService.patchMe(newUserData)
      .then(() => {
        this.SessionService.currentUser.user = Object.assign(this.SessionService.currentUser.user, newUserData)

        this.$mdDialog.hide()
        const toast = this.$mdToast
          .simple()
          .textContent('Daten erfolgreich gespeichert.')
          .action('OK')
          .position('bottom')
          .hideDelay(10000)
        this.$mdToast.show(toast)
      })
      .catch((err) => {
        console.error('err', err)
      })
  }
}

export const profileDialogComponent = {
  controller: ProfileDialogController,
  controllerAs: '$ctrl',
  clickOutsideToClose: true,
  escapeToClose: true,
  template: template({ css }),
  fullscreen: true,
  bindToController: true,
}

export const profileDialogConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('profileDialog', {
    options: () => {
      return profileDialogComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/profile/components/profile-dialog/profile-dialog.component.js